const parseList = (value) =>
  (value || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);

const envAdminUids = parseList(process.env.REACT_APP_OWNER_UIDS);
const envAdminEmails = parseList(process.env.REACT_APP_OWNER_EMAILS).map((email) => email.toLowerCase());

export const ADMIN_UIDS = envAdminUids.length > 0
  ? envAdminUids
  : ['wjeKi75LkuYqx1oZYtt2wvlRvXD3'];

export const ADMIN_EMAILS = envAdminEmails.length > 0
  ? envAdminEmails
  : ['mohebullah2015@gmail.com'];

export const isAdminUser = (user) => {
  if (!user) return false;
  if (ADMIN_UIDS.includes(user.uid)) return true;
  if (user.email && ADMIN_EMAILS.includes(user.email.toLowerCase())) return true;
  return false;
};
